import {Equipe, Game, Match} from '@/models';
import playerStore from '@/stores/modules/player';

export class DoubletteHelper {
	
	public static matchNJ(game: Game): void {
		const players = playerStore.state.players;
		const method = 'match'+players.length+'J';
		console.log('Create game with ', method);
		this['match'+players.length+'J'](game);
	}
	
	private static match4J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = new Equipe();
		const E2M1 = new Equipe();
		if (fixe) {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
		} else {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
		}
		M1.addEquipes([E1M1, E2M1]);
		
		const E1M2 = new Equipe();
		const E2M2 = new Equipe();
		if (fixe) {
			E1M2.addPlayer(J1).addPlayer(J2);
			E2M2.addPlayer(J3).addPlayer(J4);
		} else {
			E1M2.addPlayer(J4).addPlayer(J1);
			E2M2.addPlayer(J2).addPlayer(J3);
		}
		M2.addEquipes([E1M2, E2M2]);
		
		
		const E1M3 = new Equipe();
		const E2M3 = new Equipe();
		if (fixe) {
			E1M3.addPlayer(J1).addPlayer(J2);
			E2M3.addPlayer(J3).addPlayer(J4);
		} else {
			E1M3.addPlayer(J4).addPlayer(J2);
			E2M3.addPlayer(J1).addPlayer(J3);
		}
		M3.addEquipes([E1M3, E2M3]);
	}
	
	private static match6J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = new Equipe();
		const E2M1 = new Equipe();
		if (fixe) {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
		} else {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
		}
		M1.addEquipes([E1M1, E2M1]);
		
		const E1M2 = new Equipe();
		const E2M2 = new Equipe();
		if (fixe) {
			E1M2.addPlayer(J5).addPlayer(J6);
			E2M2.addPlayer(J3).addPlayer(J4);
		} else {
			E1M2.addPlayer(J3).addPlayer(J6);
			E2M2.addPlayer(J5).addPlayer(J4);
		}
		M2.addEquipes([E1M2, E2M2]);
		
		
		const E1M3 = new Equipe();
		const E2M3 = new Equipe();
		if (fixe) {
			E1M3.addPlayer(J1).addPlayer(J2);
			E2M3.addPlayer(J5).addPlayer(J6);
		} else {
			E1M3.addPlayer(J5).addPlayer(J2);
			E2M3.addPlayer(J1).addPlayer(J6);
		}
		M3.addEquipes([E1M3, E2M3]);
	}
	
	private static match8J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		const J7 = players[6];
		const J8 = players[7];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = new Equipe();
		const E2M1 = new Equipe();
		const E3M1 = new Equipe();
		const E4M1 = new Equipe();
		if (fixe) {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
			E3M1.addPlayer(J5).addPlayer(J6);
			E4M1.addPlayer(J7).addPlayer(J8);
		} else {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
			E3M1.addPlayer(J5).addPlayer(J6);
			E4M1.addPlayer(J7).addPlayer(J8);
		}
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		
		const E1M2 = new Equipe();
		const E2M2 = new Equipe();
		const E3M2 = new Equipe();
		const E4M2 = new Equipe();
		if (fixe) {
			E1M2.addPlayer(J1).addPlayer(J2);
			E2M2.addPlayer(J3).addPlayer(J4);
			E3M2.addPlayer(J5).addPlayer(J6);
			E4M2.addPlayer(J7).addPlayer(J8);
		} else {
			E1M2.addPlayer(J7).addPlayer(J1);
			E2M2.addPlayer(J5).addPlayer(J3);
			E3M2.addPlayer(J2).addPlayer(J6);
			E4M2.addPlayer(J4).addPlayer(J8);
		}
		M2.addEquipes([E1M2, E2M2]);
		M2.addEquipes([E3M2, E4M2]);
		
		
		const E1M3 = new Equipe();
		const E2M3 = new Equipe();
		const E3M3 = new Equipe();
		const E4M3 = new Equipe();
		if (fixe) {
			E1M3.addPlayer(J1).addPlayer(J2);
			E2M3.addPlayer(J3).addPlayer(J4);
			E3M3.addPlayer(J5).addPlayer(J6);
			E4M3.addPlayer(J7).addPlayer(J8);
		} else {
			E1M3.addPlayer(J4).addPlayer(J2);
			E2M3.addPlayer(J7).addPlayer(J3);
			E3M3.addPlayer(J1).addPlayer(J5);
			E4M3.addPlayer(J6).addPlayer(J8);
		}
		M3.addEquipes([E1M3, E2M3]);
		M3.addEquipes([E3M3, E4M3]);
	}
	
	private static match10J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		const J7 = players[6];
		const J8 = players[7];
		const J9 = players[8];
		const J10 = players[9];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		const M4 = new Match(); game.addMatch(M4);
		const M5 = new Match(); game.addMatch(M5);
		
		const E1M1 = new Equipe();
		const E2M1 = new Equipe();
		const E3M1 = new Equipe();
		const E4M1 = new Equipe();
		
		if (fixe) {
			E1M1.addPlayer(J1).addPlayer(J2);
			E2M1.addPlayer(J3).addPlayer(J4);
			E3M1.addPlayer(J5).addPlayer(J6);
			E4M1.addPlayer(J7).addPlayer(J8);
		} else {
			E1M1.addPlayer(J1).addPlayer(J2); // 1-2
			E2M1.addPlayer(J3).addPlayer(J4); // 3-4
			E3M1.addPlayer(J5).addPlayer(J6); // 5-6
			E4M1.addPlayer(J7).addPlayer(J8); // 7-8
		}
		M1.addEquipes([E1M1, E2M1]); // 12
		M1.addEquipes([E3M1, E4M1]); // 34
		// No E5
		
		const E5M2 = new Equipe();
		const E1M2 = new Equipe();
		const E2M2 = new Equipe();
		const E3M2 = new Equipe();
		
		if (fixe) {
			E1M2.addPlayer(J1).addPlayer(J2);
			E2M2.addPlayer(J3).addPlayer(J4);
			E3M2.addPlayer(J5).addPlayer(J6);
			E5M2.addPlayer(J9).addPlayer(J10);
		} else {
			E1M2.addPlayer(J5).addPlayer(J2); // 2-5
			E2M2.addPlayer(J9).addPlayer(J4); // 4-9
			E3M2.addPlayer(J1).addPlayer(J6); // 1-6
			E5M2.addPlayer(J3).addPlayer(J10);// 3-10
		}
		M2.addEquipes([E1M2, E5M2]); // 15
		M2.addEquipes([E2M2, E3M2]); // 23
		// No E4
		
		const E4M3 = new Equipe();
		const E5M3 = new Equipe();
		const E1M3 = new Equipe();
		const E2M3 = new Equipe();
		
		if (fixe) {
			E1M3.addPlayer(J1).addPlayer(J2);
			E2M3.addPlayer(J3).addPlayer(J4);
			E4M3.addPlayer(J7).addPlayer(J8);
			E5M3.addPlayer(J9).addPlayer(J10);
		} else {
			E1M3.addPlayer(J1).addPlayer(J4);  // 1-4
			E2M3.addPlayer(J8).addPlayer(J10); // 8-10
			E4M3.addPlayer(J2).addPlayer(J7);  // 2-7
			E5M3.addPlayer(J3).addPlayer(J9);  // 3-9
		}
		M3.addEquipes([E1M3, E4M3]); // 14
		M3.addEquipes([E2M3, E5M3]); // 25
		// No E3
		
		const E3M4 = new Equipe();
		const E4M4 = new Equipe();
		const E5M4 = new Equipe();
		const E1M4 = new Equipe();
		
		if (fixe) {
			E1M4.addPlayer(J1).addPlayer(J2);
			E3M4.addPlayer(J5).addPlayer(J6);
			E4M4.addPlayer(J7).addPlayer(J8);
			E5M4.addPlayer(J9).addPlayer(J10);
		} else {
			E1M4.addPlayer(J7).addPlayer(J2);  // 1-7
			E3M4.addPlayer(J9).addPlayer(J6);  // 6-9
			E4M4.addPlayer(J1).addPlayer(J8);  // 1-8
			E5M4.addPlayer(J5).addPlayer(J10); // 5-10
		}
		M4.addEquipes([E4M4, E5M4]); // 45
		M4.addEquipes([E1M4, E3M4]); // 13
		// No E2
		
		const E2M5 = new Equipe();
		const E3M5 = new Equipe();
		const E4M5 = new Equipe();
		const E5M5 = new Equipe();
		
		if (fixe) {
			E2M5.addPlayer(J3).addPlayer(J4);
			E3M5.addPlayer(J5).addPlayer(J6);
			E4M5.addPlayer(J7).addPlayer(J8);
			E5M5.addPlayer(J9).addPlayer(J10);
		} else {
			E2M5.addPlayer(J9).addPlayer(J4);  // 9-7
			E3M5.addPlayer(J3).addPlayer(J6);  // 3-7
			E4M5.addPlayer(J5).addPlayer(J8);  // 5-8
			E5M5.addPlayer(J7).addPlayer(J10); // 7-10
		}
		M5.addEquipes([E2M5, E4M5]); // 24
		M5.addEquipes([E3M5, E5M5]); // 35
		// No E1
		
		
		
		
	}
	
}